
import { useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getBlobName, getTokenAndFetchHeaders, getFileIcon, getFileName } from '../utils';
import { apiRequest } from '../utils/authConfig';
import { useMsal, account, AuthContext } from '../utils/authContext';
import ReactGA from 'react-ga';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import LoadingButton from '../common/LoadingButton';
import { deleteFile } from './FileService';

const apiKey = process.env.REACT_APP_BACKEND_KEY ? process.env.REACT_APP_BACKEND_KEY : '';

interface FileProps {
    url?: string;
    onDelete: Function;
    onError: Function;
}

export const DisplayMeta = ({ url }: { url: string }) => {
    const name = getFileName(url);
    const icon: IconProp = getFileIcon(url);

    return (<>
        <FontAwesomeIcon style={{ display: "block", margin: "3rem auto 1rem" }} size="6x" icon={icon} />
        <small style={{ display: "block", textAlign: "center", position: "absolute", bottom: 0, padding: "0.5em 1em", backgroundColor: "rgba(0,0,0, 0.5)", zIndex: 10, width: "100%", color: "#fff" }}>{name}</small>
    </>)
}
const FileCard = ({ url, onDelete, onError }: FileProps) => {
    const args = useMemo(() => ({ ...apiRequest, account }), []);
    const { getToken }: AuthContext = useMsal();
    const [downloading, setDownloading] = useState(false);
    const [deleting, setDeleting] = useState(false);

    if (!url) return null;

    const handleDelete = async (fileName: string) => {
        try {
            setDeleting(true);
            await deleteFile(fileName, getToken, args);
            await onDelete();
        } catch (err: any) {
            setDeleting(false);
            onError(err);
        }
    };

    const handleDeleteClick = async () => {
        const parts = url.split('/');
        const fileId = parts[parts.length - 1];
        await handleDelete(fileId);
    };

    const handleDownload = async () => {
        setDownloading(true);
        const api = process.env['REACT_APP_BACKEND_URL'];
        const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
        const blobName = 'files/' + getBlobName(url);
        try {
            const res = await fetch(`${api}/file/download/?blobName=${encodeURIComponent(blobName)}`, {
                method: 'Get',
                headers,
            });
            if (!res.ok) {
                throw new Error("Download failed. Try again.");
            }
            const token = await res.text();
            const filePath = `${url}?${token}`;
            ReactGA.event({
                category: "File",
                action: "download",
                label: "File Download",
                dimension1: filePath
            });
            window.location.href = filePath;
        } catch (err: any) {
            onError(err);
        } finally {
            setDownloading(false);
        }
    }

    return <Card style={{ width: '216px', display: "inline-block" }} className="me-2 mb-2">
        <div style={{ width: "216px", height: "216px", overflow: "hidden", position: "relative", cursor: "pointer" }}>
            <DisplayMeta url={url} />
        </div>
        <Card.Footer className="p-2 clearfix">
            <LoadingButton
                loading={deleting}
                variant="danger"
                className="float-end"
                size="sm"
                onClick={handleDeleteClick}
            >Delete</LoadingButton>
            <LoadingButton
                loading={downloading}
                variant="outline-secondary"
                size="sm"
                onClick={handleDownload}
            >Download</LoadingButton>
        </Card.Footer>
    </Card>
}
export default FileCard;
